var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    hardline = _require$doc$builders.hardline,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var printTrueBody = function printTrueBody(node, path, print) {
  if (node.trueBody.type === 'Block') {
    return concat([' ', path.call(print, 'trueBody')]);
  }

  var ifWithinIf = node.trueBody.type === 'IfStatement';
  return group(indent(concat([ifWithinIf ? hardline : line, path.call(print, 'trueBody')])));
};

var printFalseBody = function printFalseBody(node, path, print) {
  if (node.falseBody.type === 'Block' || node.falseBody.type === 'IfStatement') {
    return concat([' ', path.call(print, 'falseBody')]);
  }

  return group(indent(concat([line, path.call(print, 'falseBody')])));
};

var printElse = function printElse(node, path, print) {
  if (node.falseBody) {
    var elseOnSameLine = node.trueBody.type === 'Block';
    return concat([elseOnSameLine ? ' ' : hardline, 'else', printFalseBody(node, path, print)]);
  }

  return '';
};

var IfStatement = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat([group(concat(['if (', indent(concat([softline, path.call(_print, 'condition')])), softline, ')'])), printTrueBody(node, path, _print), printElse(node, path, _print)]);
  }
};
module.exports = IfStatement;